import { clearUserProfile } from './userProfileStorage';
import { authService } from '../services/authService';
import { ROUTE_ENUM } from '../routes/RoutesConstant';
import mqttService from '../services/mqttService';

/** Set while Amplify signOut is finishing — keeps ProtectedRoute on login. */
export const LOGOUT_IN_PROGRESS_KEY = 'rapchik_logout_in_progress';

export function isLogoutInProgress() {
  try {
    return sessionStorage.getItem(LOGOUT_IN_PROGRESS_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Instant navigation to login; Cognito sign-out runs in the background.
 */
export function performLogout(navigate) {
  try {
    sessionStorage.setItem(LOGOUT_IN_PROGRESS_KEY, '1');
  } catch {
    // sessionStorage may be unavailable
  }

  clearUserProfile();
  mqttService.disconnect();

  navigate(ROUTE_ENUM.AUTH_LOGIN.routePath, { replace: true });

  authService.signOut().catch((error) => {
    console.error('Error signing out:', error);
  }).finally(() => {
    try {
      sessionStorage.removeItem(LOGOUT_IN_PROGRESS_KEY);
    } catch {
      // ignore
    }
  });
}
